import {
  VITE_API_URL,
  VITE_ENV_NAME,
  VITE_IS_PUBLIC_SITE,
  VITE_PRODUCT_NAME,
} from '@/config';

export const isRS = () => {
  return VITE_PRODUCT_NAME === 'rs';
};

export const isPS = () => {
  return VITE_IS_PUBLIC_SITE === 'true';
};

export const isProd = () => {
  return ['prod', 'preprod'].includes(VITE_ENV_NAME);
};

/**stgで事故繰越のテストを行うための特別対応のフラグ */
export const isStgOfAccidentCarriedForwardTest = () => {
  return ['stg'].includes(VITE_ENV_NAME);
};

/**
 * 原則、{@link isProd} を使うこと。preprod と prod のロジック的な差分がないようにするため。
 */
export const isProdOnly = () => {
  return VITE_ENV_NAME === 'prod';
};

export const isOnlyLocalhost = () => {
  return (
    location.hostname === 'localhost' && VITE_API_URL.includes('localhost')
  );
};
export const isDevMode = () => {
  return isOnlyLocalhost() || VITE_ENV_NAME === 'dev';
};

// via G-Net for RS
const rsGNetDomains = [
  'rs.hq.admix.go.jp',
  'stg.rs.hq.admix.go.jp',
  'dev.rs.hq.admix.go.jp',
];

// via Internet for RS
const rsInternetDomains = [
  'app.rssystem.go.jp',
  'app.stg.rssystem.go.jp',
  'app.dev.rssystem.go.jp',
];

const bnsLGWANDomains = [
  'stg.bns.kpn1.asp.lgwan.jp',
  'training.bns.kpn1.asp.lgwan.jp',
  'demo.bns.kpn1.asp.lgwan.jp',
  'bns.kpn1.asp.lgwan.jp',
];

const proxyRequiredDomains = isRS()
  ? [
      ...rsGNetDomains,
      ...rsInternetDomains,
      // rssystem.go.jp とかの公開サイトは、プロキシ不要
    ]
  : bnsLGWANDomains;

export const isProxyRequired = () => {
  return (
    // プロキシが必要なドメインの場合
    proxyRequiredDomains.some((domain) => location.hostname === domain) ||
    // もしくは、localhost の場合
    isOnlyLocalhost()
  );
};

// rsGNetDomains の場合、ネットワーク経路的に、Sendgrid が使えないため、パスワードリセットのボタンを表示しない
// そもそも、rsGNetDomains は、基本 GIMA による SSO 認証をしているため、パスワードリセットの必要性がないはず？
// なんなら、そもそもEメールアドレス・パスワードの入力項目も必要ないかもしれない。
export const isPasswordResettable = () => {
  return !rsGNetDomains.some((domain) => location.hostname === domain);
};
